import { render, staticRenderFns } from "./PopupResetPassword.vue?vue&type=template&id=0cc06946"
import script from "./PopupResetPassword.vue?vue&type=script&lang=ts"
export * from "./PopupResetPassword.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports